import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import usePermissions from '@afosto/utils-react/permissions/usePermissions';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Address from '@afosto/app-components-react/Address';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import Property from '@afosto/app-components-react/Property';
import getFullName from '@afosto/utils/getFullName';
import translations from './translations';

const AddressSection = ({ isLoading, shippingAddress, showShippingAddress, billingAddress }) => {
  const intl = useIntl();
  const [hasPermissions, UnauthorizedComponent] = usePermissions(['rel:contacts:read']);

  if (!hasPermissions()) {
    return (
      <Card>
        <CardHeader
          title={intl.formatMessage(translations.title)}
          titleTypographyProps={{ variant: 'h6' }}
        />
        <CardContent>
          <UnauthorizedComponent showActions={false} />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        <LoadingWrapper isLoading={isLoading}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Property
                label={intl.formatMessage(translations.billing.title)}
                value={
                  <>
                    {billingAddress && (
                      <Address
                        company={billingAddress.organisation}
                        fullName={getFullName(billingAddress)}
                        addressLine1={billingAddress.address_line_1}
                        addressLine2={billingAddress.address_line_2}
                        postalCode={billingAddress.postal_code}
                        city={billingAddress.locality}
                        country={billingAddress.country_code}
                        administrativeArea={billingAddress.administrative_area}
                      />
                    )}

                    {!billingAddress && (
                      <Typography variant="body2">
                        {intl.formatMessage(translations.billing.emptyMessage)}
                      </Typography>
                    )}
                  </>
                }
              />
            </Grid>
            {showShippingAddress && (
              <Grid item xs={12} md={6}>
                <Property
                  label={intl.formatMessage(translations.shipping.title)}
                  value={
                    <>
                      {shippingAddress && (
                        <Address
                          company={shippingAddress.organisation}
                          fullName={getFullName(shippingAddress)}
                          addressLine1={shippingAddress.address_line_1}
                          addressLine2={shippingAddress.address_line_2}
                          postalCode={shippingAddress.postal_code}
                          city={shippingAddress.locality}
                          country={shippingAddress.country_code}
                          administrativeArea={shippingAddress.administrative_area}
                        />
                      )}

                      {!shippingAddress && (
                        <Typography variant="body2">
                          {intl.formatMessage(translations.shipping.emptyMessage)}
                        </Typography>
                      )}
                    </>
                  }
                />
              </Grid>
            )}
          </Grid>
        </LoadingWrapper>
      </CardContent>
    </Card>
  );
};

AddressSection.propTypes = {
  isLoading: PropTypes.bool,
  shippingAddress: PropTypes.object,
  showShippingAddress: PropTypes.bool,
  billingAddress: PropTypes.object,
};

AddressSection.defaultProps = {
  isLoading: false,
  shippingAddress: null,
  showShippingAddress: true,
  billingAddress: null,
};

export default AddressSection;
